import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { CheckinCardItemProps } from '../CheckinCardItem/CheckinCardItem';

export interface CheckinCardProps extends React.HTMLAttributes<HTMLDivElement> {
	className?: string;
	children: React.ReactElement<CheckinCardItemProps> | React.ReactElement<CheckinCardItemProps>[];
	padding?: string;
}

const CheckinCard: React.FC<CheckinCardProps> = ({ className, children, padding, style, ...rest }) => {
	const { CheckinCard: theme } = useTheme('CheckinCard');

	return (
		<div {...rest} className={cn(theme.root, className)} style={{ ...style, padding }}>
			{children}
		</div>
	);
};

export default CheckinCard;
